import { createFileRoute, notFound } from "@tanstack/react-router";
import {
  CmsRoutePage,
  loadCmsRoute,
  normalizeRouteSearchParams,
  renderCmsHead,
} from "@core/cms/cms-route";

const pathFromSplat = (splat: string | undefined) => {
  const normalized = splat?.replace(/^\/+|\/+$/g, "") ?? "";
  return normalized ? `/${normalized}` : "/";
};

const assertPublicPath = (path: string) => {
  if (
    path === "/admin" ||
    path.startsWith("/admin/") ||
    path === "/api" ||
    path.startsWith("/api/")
  ) {
    throw notFound();
  }
};

export const Route = createFileRoute("/$")({
  validateSearch: normalizeRouteSearchParams,
  loader: ({ context, location, params }) => {
    const path = pathFromSplat(params._splat);
    assertPublicPath(path);
    return loadCmsRoute({
      context,
      path,
      searchParams: normalizeRouteSearchParams(location.search),
    });
  },
  head: ({ loaderData }) => renderCmsHead(loaderData?.seo),
  component: SplatPage,
});

function SplatPage() {
  const data = Route.useLoaderData();
  return <CmsRoutePage data={data} />;
}
